// Pitch geometry by team size (§3 pitch table). Origin = centre spot; +x → away goal, +y → north
// touchline, +z up. All values verbatim from §3. Penalty-box scaling lands with the rules slice.

export type TeamSize = 1 | 2 | 3 | 5 | 11;

/** Goalpost radius (§6.2 references POST_R but §17 gives no value — chosen; see DEVIATIONS D8). */
export const POST_R = 0.06;

export interface PitchDims {
  readonly length: number; // full length (x extent), m
  readonly width: number; // full width (y extent), m
  readonly goalWidth: number; // full goal mouth, m
  readonly barH: number; // crossbar height BAR_H, m
  readonly restartClearance: number; // scaled 9.15 m clearance, m
  readonly goalAreaDepth: number; // scaled 6-yard box depth — goal-kick spot (§6.2); ~5.5 m × length/105
  readonly penaltyBoxDepth: number; // scaled 18-yard box depth (§6.2 penalty); ~16.5 m × length/105
  readonly penaltyBoxHalfWidth: number; // scaled 18-yard box half-width; ~20.16 m × width/68
  readonly penaltySpotDist: number; // scaled penalty spot distance from the goal line; ~11 m × length/105
}

// Boxes/spots scale proportionally (§3 "Penalty box scales proportionally"); base = 11v11 real values
// 5.5 / 16.5 / 20.16 / 11 m. See DEVIATIONS (no §17 values, chosen like D8/POST_R).
export const PITCH: Readonly<Record<TeamSize, PitchDims>> = Object.freeze({
  1: Object.freeze({ length: 25, width: 15, goalWidth: 3.0, barH: 1.8, restartClearance: 4.0, goalAreaDepth: 1.3, penaltyBoxDepth: 3.9, penaltyBoxHalfWidth: 4.4, penaltySpotDist: 2.6 }),
  2: Object.freeze({ length: 30, width: 18, goalWidth: 3.0, barH: 1.8, restartClearance: 4.0, goalAreaDepth: 1.6, penaltyBoxDepth: 4.7, penaltyBoxHalfWidth: 5.3, penaltySpotDist: 3.1 }),
  3: Object.freeze({ length: 35, width: 20, goalWidth: 3.0, barH: 1.8, restartClearance: 4.0, goalAreaDepth: 1.8, penaltyBoxDepth: 5.5, penaltyBoxHalfWidth: 5.9, penaltySpotDist: 3.7 }),
  5: Object.freeze({ length: 42, width: 25, goalWidth: 5.0, barH: 2.0, restartClearance: 6.0, goalAreaDepth: 2.2, penaltyBoxDepth: 6.6, penaltyBoxHalfWidth: 7.4, penaltySpotDist: 4.4 }),
  11: Object.freeze({ length: 105, width: 68, goalWidth: 7.32, barH: 2.44, restartClearance: 9.15, goalAreaDepth: 5.5, penaltyBoxDepth: 16.5, penaltyBoxHalfWidth: 20.16, penaltySpotDist: 11 }),
});
